export const jetsProposal = {
  slug: "jets",
  clientName: "New York Jets",
  accessEnvKey: "VITE_PROPOSAL_JETS_ACCESS_CODE",
  comedyuoLogo: "/comedyuo-logo-white.png",
  heroImage: "https://storage.googleapis.com/cuo-website/Best+Comedy+Shows+.jpg",
  heroImageAlt: "A wide shot of a packed crowd at a ComedyUO show",
  heroEyebrow: "New York Jets · Private events",
  heroHeadline: "A private night of comedy.",
  heroSubheadline:
    "Prepared for the Partnerships team and clients. Standout comedy. Thoughtful hospitality. A New York room worth bringing your clients into.",
  intro:
    "ComedyUO pairs top-tier comedians with iconic New York venues for an evening of laughter, hospitality, and connection, tailored to the Jets Partnerships team and your guests.",
  pillars: [
    {
      number: "01",
      title: "The comedy",
      body: "A 75-minute show. Four comedians. One emcee. You review a curated talent shortlist and align on tone and off-limit topics in advance. Corporate-friendly sets, built around the people in the room.",
      image: "https://storage.googleapis.com/cuo-website/Chris+Distefano+at+Wilson.jpg",
      imageAlt: "Chris Distefano performing at a ComedyUO show",
    },
    {
      number: "02",
      title: "Food and beverage",
      body: "Open bar before, during, and after the show, so clients have time to connect on either side of the performance. Dining and a premium bar can be added. ComedyUO can handle food and beverage, or coordinate with the venue.",
      image: "https://storage.googleapis.com/cuo-website/UOxParagon_51624-842photo-163.jpg",
      imageAlt: "Guests at a ComedyUO night at Paragon Sports",
    },
    {
      number: "03",
      title: "The room",
      body: "Five distinctive New York options. 13th Storey and Scuba Network are available in December. Paragon and The Seville are available in January. Zabar's is open starting in February.",
      image: "https://storage.googleapis.com/cuo-website/Judy%20Gold%20Zabar%27s.jpg",
      imageAlt: "Judy Gold performing at Zabar's",
    },
  ],
  runOfShow: [
    {
      time: "45 min",
      title: "Welcome and cocktails",
      body: "Doors open. Drinks in hand. Time for the Partnerships team and guests to settle in before the show.",
    },
    {
      time: "75 min",
      title: "Private comedy show",
      body: "Four comedians and one emcee. A hosted, corporate-friendly set in a room that is yours for the night.",
    },
    {
      time: "30 min",
      title: "Post-show mingling",
      body: "The bar stays open. Guests stay in the room and keep the conversation going after the last set.",
    },
  ],
  venues: [
    {
      id: "13th-storey",
      name: "13th Storey",
      when: "Available in December, 30–60 guests",
      neighborhood: "Midtown · Near Grand Central",
      body: "A private Midtown rooftop lounge near Grand Central, with refined interiors and an intimate atmosphere for a hosted client evening.",
      image: "https://storage.googleapis.com/cuo-website/Rooms%20We've%20Fooled%20Magic%20Show.jpg",
      imageAlt: "ComedyUO at 13th Storey",
      links: [
        {
          label: "View photos",
          href: "https://drive.google.com/drive/folders/1vYgRWIPq71e8Tcn-x9pZaP1aAZLQy6V7",
        },
      ],
    },
    {
      id: "scuba-network",
      name: "Scuba Network",
      when: "Available in December, 40–60 guests",
      neighborhood: "Chelsea",
      body: "The dive shop on West 21st Street. Masks, fins, and a retail floor that feels nothing like a standard event space.",
      image:
        "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-27%20at%205.56.10%E2%80%AFPM.png",
      imageAlt: "Scuba Network",
      links: [
        {
          label: "View photos",
          href: "https://drive.google.com/drive/folders/1ftfEluuUsN68_ssQrU94UgllpebGfnYZ",
        },
      ],
    },
    {
      id: "seville",
      name: "The Seville",
      when: "Available in January, 50 guests",
      neighborhood: "NoMad",
      body: "A stylish cocktail lounge with a polished evening atmosphere. A natural setting for welcome drinks, conversation, and a private comedy show.",
      image:
        "https://storage.googleapis.com/cuo-website/Screenshot%202026-10-09%20at%201.01.39%E2%80%AFPM.png",
      imageAlt: "The Seville comedy room",
      links: [
        {
          label: "Instagram",
          href: "https://www.instagram.com/thesevillenyc/",
        },
      ],
    },
    {
      id: "paragon",
      name: "Paragon Sports",
      when: "Available in January, 80–120 guests",
      neighborhood: "Union Square",
      body: "An unexpected sports setting with a ComedyUO track record. Bring the spirit of sport into a memorable client experience at Paragon Sports.",
      image: "https://storage.googleapis.com/cuo-website/Comedy+at+Paragon+Sports.jpg",
      imageAlt: "ComedyUO show on the floor at Paragon Sports",
      links: [
        {
          label: "View photos",
          href: "https://drive.google.com/drive/folders/1uDHiDK2F6kSk5QBB1rxRqzBVS5cjA6VA",
        },
      ],
    },
    {
      id: "zabars",
      name: "Zabar's",
      when: "Open starting in February, 40–60 guests",
      neighborhood: "Upper West Side",
      body: "A classic New York institution and past ComedyUO venue. A distinctive backdrop for a warm, intimate evening of comedy and hospitality.",
      image: "https://storage.googleapis.com/cuo-website/Dave+Attell+at+Zabar's.jpg",
      imageAlt: "Dave Attell performing at Zabar's",
      links: [
        {
          label: "View photos",
          href: "https://drive.google.com/drive/folders/1hpB5996gxDhCyo7EauQ6-8IDgmYrRSVp",
        },
      ],
    },
  ],
  handles: [
    "Venue and talent bookings",
    "Production, equipment, and setup",
    "Show management",
    "Bar staffing",
    "Food and beverage coordination",
    "Breakdown",
  ],
  contactName: "Mike Zbyszewski",
  contactRole: "Sales & Partnerships, ComedyUO",
  contactEmail: "mike@comedyuo.com",
  contactPhone: "(310) 469-8961",
} as const;
